import { isEmpty } from "lodash";

export const EXPNT_ACTIONS = {
  EXPNT_INFO_RQ: "EXPNT_INFO_RQ",
  EXPNT_INFO_OK: "EXPNT_INFO_OK",
  EXPNT_INFO_FAIL: "EXPNT_INFO_FAIL",

  EXPNT_LIST_RQ: "EXPNT_LIST_RQ",
  EXPNT_LIST_OK: "EXPNT_LIST_OK",
  EXPNT_LIST_FAIL: "EXPNT_LIST_FAIL",

  EXPNT_UPDATE_LIST_RQ: "EXPNT_UPDATE_LIST_RQ",
  EXPNT_UPDATE_LIST_OK: "EXPNT_UPDATE_LIST_OK",
  EXPNT_UPDATE_LIST_FAIL: "EXPNT_UPDATE_LIST_FAIL",

  EXPNT_GET_RQ: "EXPNT_GET_RQ",
  EXPNT_GET_OK: "EXPNT_GET_OK",
  EXPNT_GET_FAIL: "EXPNT_GET_FAIL",

  EXPNT_ADD_RQ: "EXPNT_ADD_RQ",
  EXPNT_ADD_OK: "EXPNT_ADD_OK",
  EXPNT_ADD_FAIL: "EXPNT_ADD_FAIL",

  EXPNT_UPDATE_RQ: "EXPNT_UPDATE_RQ",
  EXPNT_UPDATE_OK: "EXPNT_UPDATE_OK",
  EXPNT_UPDATE_FAIL: "EXPNT_UPDATE_FAIL",

  EXPNT_DELETE_RQ: "EXPNT_DELETE_RQ",
  EXPNT_DELETE_OK: "EXPNT_DELETE_OK",
  EXPNT_DELETE_FAIL: "EXPNT_DELETE_FAIL",

  EXPNT_DUPLICATE_RQ: "EXPNT_DUPLICATE_RQ",
  EXPNT_DUPLICATE_OK: "EXPNT_DUPLICATE_OK",
  EXPNT_DUPLICATE_FAIL: "EXPNT_DUPLICATE_FAIL",

  EXPNT_RESET_ALL: "EXPNT_RESET_ALL",
};

export const experimentI = {
  expntInfo: {},
  expnt_experiments: [],
  expnt_info_loading: false,
  expnt_list_loading: false,
  expnt_update_list_loading: false,
  expnt_get_loading: false,
  expnt_add_loading: false,
  expnt_update_loading: false,
  expnt_delete_loading: false,
  expnt_duplicate_loading: false,
  expnt_error: null,
};

export const experimentReducer = (state: any, action: any) => {
  switch (action.type) {
    case EXPNT_ACTIONS.EXPNT_INFO_RQ:
      return { ...state, expnt_info_loading: true, error: null };
    case EXPNT_ACTIONS.EXPNT_INFO_FAIL:
      return { ...state, expnt_info_loading: false };
    case EXPNT_ACTIONS.EXPNT_INFO_OK:
      return { ...state, expnt_info_loading: false, expntInfo: action.data };

    case EXPNT_ACTIONS.EXPNT_LIST_RQ:
      return { ...state, expnt_list_loading: true, error: null };
    case EXPNT_ACTIONS.EXPNT_LIST_FAIL:
      return { ...state, expnt_list_loading: false };
    case EXPNT_ACTIONS.EXPNT_LIST_OK:
      return { ...state, expnt_list_loading: false, expnt_experiments: action.data };

    case EXPNT_ACTIONS.EXPNT_UPDATE_LIST_RQ:
      return { ...state, expnt_update_list_loading: true, error: null };
    case EXPNT_ACTIONS.EXPNT_UPDATE_LIST_FAIL:
      return { ...state, expnt_update_list_loading: false };
    case EXPNT_ACTIONS.EXPNT_UPDATE_LIST_OK:
      return {
        ...state,
        expnt_update_list_loading: false,
        expnt_experiments: [...state.expnt_experiments, ...action.data],
      };

    case EXPNT_ACTIONS.EXPNT_GET_RQ:
      return { ...state, expnt_get_loading: true, error: null };
    case EXPNT_ACTIONS.EXPNT_GET_FAIL:
      return { ...state, expnt_get_loading: false };
    case EXPNT_ACTIONS.EXPNT_GET_OK:
      return { ...state, expnt_get_loading: false };

    case EXPNT_ACTIONS.EXPNT_ADD_RQ:
      return { ...state, expnt_add_loading: true, error: null };
    case EXPNT_ACTIONS.EXPNT_ADD_FAIL:
      return { ...state, expnt_add_loading: false };
    case EXPNT_ACTIONS.EXPNT_ADD_OK:
      return {
        ...state,
        expnt_add_loading: false,
        expnt_experiments: isEmpty(action.data)
          ? [...state.expnt_experiments]
          : [action.data, ...state.expnt_experiments],
      };

    case EXPNT_ACTIONS.EXPNT_UPDATE_RQ:
      return { ...state, expnt_update_loading: true, error: null };
    case EXPNT_ACTIONS.EXPNT_UPDATE_FAIL:
      return { ...state, expnt_update_loading: false };
    case EXPNT_ACTIONS.EXPNT_UPDATE_OK:
      return {
        ...state,
        expnt_update_loading: false,
        expnt_experiments: state.expnt_experiments.map((item: any) =>
          item.id === action.data.id ? action?.data : item,
        ),
      };

    case EXPNT_ACTIONS.EXPNT_DELETE_RQ:
      return { ...state, expnt_delete_loading: true, error: null };
    case EXPNT_ACTIONS.EXPNT_DELETE_FAIL:
      return { ...state, expnt_delete_loading: false };
    case EXPNT_ACTIONS.EXPNT_DELETE_OK:
      return {
        ...state,
        expnt_delete_loading: false,
        expnt_experiments: state.expnt_experiments.filter(
          (item: any) => !action.data.includes(item.id),
        ),
      };

    case EXPNT_ACTIONS.EXPNT_DUPLICATE_RQ:
      return { ...state, expnt_duplicate_loading: true, error: null };
    case EXPNT_ACTIONS.EXPNT_DUPLICATE_FAIL:
      return { ...state, expnt_duplicate_loading: false };
    case EXPNT_ACTIONS.EXPNT_DUPLICATE_OK:
      return {
        ...state,
        expnt_duplicate_loading: false,
        expnt_experiments: isEmpty(action.data)
          ? [...state.expnt_experiments]
          : [...action.data, ...state.expnt_experiments],
      };

    case EXPNT_ACTIONS.EXPNT_RESET_ALL:
      return {
        ...state,
        expntInfo: {},
        expnt_experiments: [],
        expnt_info_loading: false,
        expnt_list_loading: false,
        expnt_update_list_loading: false,
        expnt_get_loading: false,
        expnt_add_loading: false,
        expnt_update_loading: false,
        expnt_delete_loading: false,
        expnt_duplicate_loading: false,
        expnt_error: null,
      };
    default:
      return state;
  }
};
